import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_POLICY_ABUSE_PETITION_REPORT_MODAL = createFcmConfig('policy_abuse_petition_report_modal', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
